import { Box, Typography } from "@mui/material";
import ReBox from "../../../../common/ReBox";
import LoadingWheel from "../../../../common/LoadingWheel";
import ChallengeCard from "../ChallengeCard";
import PreviousWinners from "../PreviousWinners/PreviousWinners";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { GlobalContext } from "../../../../common/Context";
import { CHALLENGES_CARD_AREA } from "../../../../../constants/ids";

const ChallengesDisplay = ({ title, campaigns, winners }) => {
  const { t } = useTranslation("CompetitionInfo");
  const { desktopView, mobileView } = useContext(GlobalContext);

  const containerStyle = {
    display: "flex",
    flexDirection: "column",
    mt: "1rem",
    padding: desktopView && "2rem",
    borderRadius: !mobileView && "1rem",
    width: "100%",
    pb: campaigns ? "0.25rem" : "2rem",
    pt: mobileView ? "1rem" : "2rem",
    borderTop: mobileView && "1px solid #C1C0C3",
    ...(!desktopView && {
      background: "none",
      boxShadow: "none",
    }),
  };
  const titleStyle = {
    fontSize: mobileView ? "1rem" : "1.5rem",
    lineHeight: 1.5,
    mb: "0.5rem",
  };
  const descriptionStyle = {
    lineHeight: 1.5,
    opacity: 0.5,
    mb: "1rem",
  };
  const campaignAreaStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: !campaigns?.length > 0 ? "center" : "space-between",
    alignItems: "center",
    alignContent: "space-around",
  };
  const noCampBoxStyle = {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignContent: "center",
    textAlign: "center",
    height: "100%",
    padding: "1rem",
  };
  const emptyTextStyle = {
    fontWeight: 500,
  };

  return (
    <ReBox style={containerStyle} divProps={{ id: CHALLENGES_CARD_AREA }}>
      <Typography variant="h2" sx={titleStyle}>
        {title}
      </Typography>
      {campaigns && (
        <Typography variant="body1" sx={descriptionStyle}>
          {t("weeklyCampaignDesc")}
        </Typography>
      )}
      <Box sx={campaignAreaStyle}>
        {!campaigns ? (
          <LoadingWheel width={3} />
        ) : campaigns?.length > 0 ? (
          campaigns.slice(0, 4).map((campaign) => (
            <>
              <ChallengeCard
                title={campaign.name}
                type={campaign.score_type}
                neededScore={campaign.score}
                prizeDesc={campaign.prizeDesc}
                entries={campaign.entries}
                startDate={campaign.start_date.value}
                endDate={campaign.end_date.value}
                banner={campaign.banner}
                id={campaign.id}
              />
            </>
          ))
        ) : (
          <Box sx={noCampBoxStyle}>
            <Typography variant="h3" sx={emptyTextStyle}>
              {t("EmptyCampTitle")}
            </Typography>
            <Typography variant="body1" sx={emptyTextStyle}>
              {t("EmptyCampDescription")}
            </Typography>
          </Box>
        )}
      </Box>
      {campaigns?.length ? <PreviousWinners winnersData={winners} /> : <></>}
    </ReBox>
  );
};

export default ChallengesDisplay;
